module.exports = __webpack_public_path__ + "media/images/person/med_torigaki_san-a03c4672cf39d9a4f14b75ac64dec943.jpg";